// extracted by mini-css-extract-plugin
export default {"container":"gAsXH","description":"VNiTP","tablet":"LsDx2","mobile":"OUK5w","smallMobile":"eW5eM"};